import React, { Fragment, useEffect, useRef, useState } from 'react'
import { useNavigate, Link, useParams } from 'react-router'
import { useTranslation } from 'react-i18next'
import Select from 'react-select'
import DatePicker from "react-datepicker"
import { Modal } from 'react-bootstrap'
import { store } from 'store/index'

import ReactSelect from 'pages/parts/ReactSelect'
import { SHOW_LOADER, HIDE_LOADER } from 'store/loader/actions'
import { httpOk, GET, POST, PUT, DELETE } from 'helpers/api'
import { handleDecimalKeyDown } from 'helpers/decimalKey'
import { formatDate, formatMoney, returnMinDate, returnSign, notify } from 'helpers/helpers'

function CreateUpdate() {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const { template } = useParams()

	const tbodyRef = useRef()
	const scrollRef = useRef()

	const [wms, setWms] = useState([])
	const [items, setItems] = useState([])
	const [employees, setEmployees] = useState([])
	const [addQuantity, setAddQuantity] = useState(1)
	const [elementsDuplicate, setElementsDuplicate] = useState([])
	const [modalTemplate, setModalTemplate] = useState({ 'bool': false, 'templates': [] })
	const [modalDeviation, setModalDeviation] = useState({ 'bool': false, 'rows': [] })
	const [data, setData] = useState({
		"items": [],
		"quantity": 0,
		"cost_price": 0,
		"total_amount": 0,
		"note": null,
		"user_login": null,
		"activeIndex": null,
		"created_at": formatDate(new Date(), 'yyyy-MM-dd'),
		'isBarcodeSearchEnabled': template === 'template_1' ? false : true
	})

	async function createUpdate(confirmDeviation = false) {
		var dataCopy = { ...data }

		if (dataCopy.items.length === 0) {
			notify(t('add_elements'))
			return
		}

		for (let i = 0; i < dataCopy.items.length; i++) {
			if (!dataCopy.items[i]['quantity']) {
				dataCopy.error = true
			}
		}

		if (dataCopy.error) {
			notify(t('check_filled_inputs'))
			return
		}

		if (!confirmDeviation) {
			const rows = returnDeviatedIngredients()
			if (rows.length) {
				// В «создать 2» раскрываем строки с подозрительным расходом, чтобы было видно, что править
				setData({
					...data,
					'items': data.items.map(item => (
						(item.ingredients || []).some(ingredient => isIngredientDeviated(ingredient, item.quantity))
							? { ...item, 'show_ingredients': true }
							: item
					))
				})
				setModalDeviation({ 'bool': true, 'rows': rows })
				return
			}
		}

		setModalDeviation({ 'bool': false, 'rows': [] })
		dataCopy.confirm_deviation = confirmDeviation

		var response;
		if (dataCopy.id) {
			response = await PUT('/documents-preparation', dataCopy, { loader: true })
		} else {
			response = await POST('/documents-preparation', dataCopy, { loader: true })
		}

		if (httpOk(response)) navigate('/documents-preparation')
	}

	function addToList(length = 1, currentData = null) {
		// Если передали актуальные данные (из handleSelectItem), используем их
		// Если нет, делаем глубокую копию текущего стейта
		var dataCopy = currentData ? { ...currentData } : JSON.parse(JSON.stringify(data));

		for (let i = 0; i < length; i++) {
			dataCopy.items.push({
				'price': '',
				'quantity': '',
				'element_id': '',
				'ingredients': [],
			})
		}

		dataCopy.activeIndex = dataCopy.items.length - 1
		countTotalAmount(dataCopy)

		setTimeout(() => {
			const byId = document.getElementById(`input-select-${dataCopy.items.length}`)
			byId.select()
		}, 200);
	}

	function deleteItem(index) {
		var dataCopy = JSON.parse(JSON.stringify(data))
		dataCopy.items.splice(index, 1)
		dataCopy.activeIndex = null

		countTotalAmount(dataCopy)
	}

	function handleInputChange(e, index) {
		var dataCopy = { ...data }
		dataCopy.items[index][e.target.name] = e.target.value.replace(/,/g, '.').replace(/[^0-9.]/g, '')

		for (let i = 0; i < dataCopy.items[index]['ingredients'].length; i++) {
			dataCopy.items[index]['ingredients'][i]['actual_quantity'] =
				Number(
					dataCopy.items[index]['ingredients'][i]['quantity'] *
					dataCopy.items[index]['quantity']
				).toFixed(4)
		}

		countTotalAmount(dataCopy)
	}

	function handleIngredientChange(e, pIndex, iIndex) {
		var dataCopy = { ...data }
		dataCopy.items[pIndex]['ingredients'][iIndex]['actual_quantity'] = e.target.value.replace(/,/g, '.').replace(/[^0-9.]/g, '')

		countTotalAmount(dataCopy)
	}

	function countTotalAmount(dataCopy) {
		dataCopy.total_amount = 0;
		dataCopy.total_quantity = 0;

		dataCopy.items.forEach(item => {
			let itemActualCost = 0;

			if (Array.isArray(item.ingredients)) {
				item.ingredients.forEach(ing => {
					itemActualCost += (Number(ing.actual_quantity) || 0) * (Number(ing.cost_price) || 0);
				});
			}

			item['actual_cost_price'] = itemActualCost;

			dataCopy.total_quantity += Number(item['quantity'] || 0);
			dataCopy.total_amount += Number(item['actual_cost_price'] || 0);
		});

		setData(dataCopy); // Финальное обновление стейта
	}

	function calculateQuantity(item, pIndex) {
		var dataCopy = { ...data }
		var index = pIndex
		dataCopy.items[index]['quantity'] = Number(item.actual_quantity / item.quantity).toFixed(4)

		for (let i = 0; i < dataCopy.items[index]['ingredients'].length; i++) {
			dataCopy.items[index]['ingredients'][i]['actual_quantity'] =
				Number(
					dataCopy.items[index]['ingredients'][i]['quantity'] *
					dataCopy.items[index]['quantity']
				).toFixed(4)
		}

		countTotalAmount(dataCopy)
	}

	// Себестоимость единицы выхода — из фактически списанных ингредиентов.
	// Повторяет логику бэка (DocumentPreparationController::resolveItemCostPrice)
	function returnUnitCostPrice(item) {
		const quantity = Number(item.quantity) || 0
		const actualCostPrice = Number(item.actual_cost_price) || 0

		if (actualCostPrice > 0 && quantity > 0) return actualCostPrice / quantity

		return Number(item.cost_price) || 0
	}

	// Фактический расход отличается от нормы больше чем в 5 раз — почти всегда опечатка
	// (600 кг мяса на 1 кг фарша). Порог тот же, что на бэке (INGREDIENT_DEVIATION_RATIO).
	function isIngredientDeviated(ingredient, outputQuantity) {
		if (ingredient.actual_quantity === '' || ingredient.actual_quantity === undefined || ingredient.actual_quantity === null) return false

		const norm = (Number(ingredient.quantity) || 0) * (Number(outputQuantity) || 0)
		if (norm <= 0) return false

		const ratio = (Number(ingredient.actual_quantity) || 0) / norm
		return ratio > 5 || ratio < 1 / 5
	}

	function returnDeviatedIngredients() {
		const rows = []
		data.items.forEach(item => {
			(item.ingredients || []).forEach(ingredient => {
				if (isIngredientDeviated(ingredient, item.quantity)) {
					rows.push({
						'product': item.name,
						'ingredient': ingredient.name,
						'norm': (Number(ingredient.quantity) || 0) * (Number(item.quantity) || 0),
						'actual': Number(ingredient.actual_quantity) || 0,
						'unit_name': ingredient.unit_name,
					})
				}
			})
		})
		return rows
	}

	function returnIngredients() {
		const item = data?.items?.[data.activeIndex];

		if (item?.ingredients?.length) {
			return item.ingredients;
		}

		return [];
	}

	// REACT SELECT LOGIC
	function handleSelectSearch(value, isScanned = false) {
		if (!value) return
		if (data.isBarcodeSearchEnabled && !value.length === 13) return
		value = value.trim();

		var elementsDuplicateCopy = [...elementsDuplicate]
		if (value.length === 13 && isScanned) {
			var weight = 0
			var plu = value
			var employee_code = null

			if (plu.length === 13 && plu.startsWith("20")) {
				// Формат баркода длина 5
				plu = value.substring(4, 7);
				employee_code = value.substring(2, 4);
				plu = parseInt(plu, 10).toString(); // Приводим к строке для точного сравнения
				employee_code = parseInt(employee_code, 10).toString(); // Приводим к строке для точного сравнения
				weight = Number(value.substring(7, 12)) / 1000;
			}

			if (plu.length === 13 && plu.startsWith("21")) {
				plu = plu.substring(4, 7);
				plu = parseInt(plu, 10).toString(); // Приводим к строке для точного сравнения
				weight = value.substring(10, 12);
			}

			var found = elementsDuplicateCopy.filter(item => String(item.plu) === plu)
			console.log(found)
			if (found?.length && employee_code) {
				var foundEmployee = employees.filter(item => item.employee_code === Number(employee_code))
				if (foundEmployee?.length) {
					found[0]['user_id'] = foundEmployee[0]['id']
					found[0]['user_name'] = foundEmployee[0]['name']
				}
			}
			if (found?.length) {
				found[0]['quantity'] = weight
				handleSelectItem(found[0], data.activeIndex, true)
			}
			return
		}

		if (!data.isBarcodeSearchEnabled) {
			var filteredItems = elementsDuplicateCopy.filter(item => item.name.toLowerCase().includes(value.toLowerCase()))
			if (filteredItems[0]) filteredItems[0]['selected'] = true
			setItems(filteredItems)
		}
	}

	async function handleSelectItem(option, index, isScanned = false) {
		var dataCopy = JSON.parse(JSON.stringify(data));

		dataCopy.items[index]['id'] = option.id
		dataCopy.items[index]['product_id'] = option.id
		dataCopy.items[index]['name'] = option.name
		dataCopy.items[index]['balance'] = option.balance
		dataCopy.items[index]['unit_name'] = option.unit_name
		dataCopy.items[index]['cost_price'] = Number(option.cost_price)
		dataCopy.items[index]['in_product'] = option.in_product
		dataCopy.items[index]['product_type_name'] = option.product_type_name
		dataCopy.items[index]['product_type_value'] = option.product_type_value
		dataCopy.items[index]['write_off_type_id'] = option.write_off_type_id
		dataCopy.items[index]['quantity'] = option.quantity ?? ''
		dataCopy.items[index]['user_id'] = option.user_id ?? ''
		dataCopy.items[index]['user_name'] = option.user_name ?? ''
		dataCopy.isScanned = isScanned

		const response = await GET(`/documents-preparation-ingredients?product_id=${option.id}&wms_id=${data.from_wms_id}`, {}, { loader: true })
		if (httpOk(response)) {
			dataCopy.items[index]['ingredients'] = response.data

			if (dataCopy.items[index]['quantity'] > 0) {
				for (let i = 0; i < dataCopy.items[index]['ingredients'].length; i++) {
					dataCopy.items[index]['ingredients'][i]['actual_quantity'] =
						Number(
							dataCopy.items[index]['ingredients'][i]['quantity'] *
							dataCopy.items[index]['quantity']
						).toFixed(4)
				}
			}

			countTotalAmount(dataCopy)

			if (isScanned) addToList(1, dataCopy);
			if (!isScanned) countTotalAmount(dataCopy);
		}
	}

	function toggleItemIngredients(index) {
		var dataCopy = JSON.parse(JSON.stringify(data));
		dataCopy.items[index]['show_ingredients'] = !dataCopy.items[index]['show_ingredients']
		setData(dataCopy)
	}

	function handleSelectEmployee(option, index) {
		var dataCopy = JSON.parse(JSON.stringify(data));

		dataCopy.items[index]['user_id'] = option.id
		dataCopy.items[index]['user_name'] = option.name

		setData(dataCopy)
	}

	function handleClearSelect(index) {
		var dataCopy = JSON.parse(JSON.stringify(data));

		dataCopy.items[index]['user_id'] = null
		dataCopy.items[index]['user_name'] = null

		setData(dataCopy)
	}

	function closeMenu() {
		setTimeout(() => {
			var elementsCopy = [...items]
			for (let i = 0; i < elementsCopy.length; i++) {
				elementsCopy[i].selected = false
			}
			elementsCopy[0].selected = true
			setItems(elementsCopy)
		}, 100);
	}

	function handleTableKeyDown(event) {
		event.stopPropagation();
		var currentIndex = items.findIndex(el => el.selected);
		if (currentIndex >= 0) {
			var elementsCopy = [...items]
			elementsCopy[currentIndex].selected = false
			switch (event.key) {
				case "ArrowUp":
					if (currentIndex === 0) {
						elementsCopy[items.length - 1].selected = true
						currentIndex = items.length - 1
					} else {
						elementsCopy[currentIndex - 1].selected = true
					}
					scrollRef.current.scrollTop = (currentIndex * 29.6) - 59.2
					break;
				case "ArrowDown":
					if (currentIndex === items.length - 1) {
						elementsCopy[0].selected = true
						currentIndex = 0
					} else {
						elementsCopy[currentIndex + 1].selected = true
					}
					scrollRef.current.scrollTop = (currentIndex * 29.6)
					break;
				default: break;
			}

			setItems(elementsCopy)
		}
	}
	// REACT SELECT LOGIC

	// TEMPLATE LOGIC

	async function toggleModalTemplate(bool = false) {
		if (bool) {
			const response = await GET(`/documents-preparation-templates?wms_id=${data.wms_id}`, {}, { loader: true })
			if (httpOk(response)) {
				setModalTemplate({ ...modalTemplate, 'bool': bool, 'templates': response })
			}
		} else {
			setModalTemplate({ ...modalTemplate, 'bool': bool, 'templates': [] })
		}
	}

	function handleSelectTemplate(item) {
		setData({
			...data,
			'items': item.items
		})
		toggleModalTemplate()
	}

	async function deleteTemplate(item) {
		await DELETE(`/documents-preparation-templates/${item.document_order_id}`, {}, { loader: true })
		toggleModalTemplate()
	}
	// TEMPLATE LOGIC

	async function getData() {
		store.dispatch(SHOW_LOADER());

		var response
		response = await GET(`/helper/wms`, {}, { loader: true })
		if (httpOk(response)) setWms(response.data)

		response = await GET(`/helper/employees`, {}, { loader: true })
		if (httpOk(response)) setEmployees(response.data)

		store.dispatch(HIDE_LOADER());
	}

	async function getProducts(wmsId) {
		var filterUrl = "/documents-preparation-products"
		var urlParams = ""

		if (wmsId)
			urlParams += returnSign(urlParams) + 'wms_id=' + wmsId
		if (template === 'template_2')
			urlParams += returnSign(urlParams) + 'has_plu=' + true

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setItems(response.data)
			setElementsDuplicate(response.data)
		}
	}

	useEffect(() => {
		getData()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<div className="d-flex text-truncate">
					<h4 className="vertical-center">
						{t('preparation')}
					</h4>
					<div className="vertical-center mt-1">
						<i className="uil uil-angle-double-right fz-20"></i>
					</div>
					<div className="vertical-center mt-1">
						<h6>{t('create')}</h6>
					</div>
				</div>
				<div className="d-flex gap-1">
					<button type="button" className="btn btn-primary btn-rounded"
						onClick={() => toggleModalTemplate(true)}>
						{t('templates')}
					</button>
				</div>
			</div>

			<form autoComplete="off">
				<div className="card mb-3">
					<div className="card-body">
						<div className="row">
							<div className="col-md-2">
								<div className="form-group">
									<label>{t('date')}<span className="required-mark">*</span></label>
									<div className="calendar-input">
										<DatePicker
											showMonthDropdown
											showYearDropdown
											dropdownMode="select"
											yearDropdownItemNumber={2}
											className="form-control"
											dateFormat="dd.MM.yyyy"
											selected={data.created_at ? new Date(data.created_at) : ''}
											onChange={(date) => setData({ ...data, 'created_at': formatDate(date, 'yyyy-MM-dd') })}
											minDate={returnMinDate(new Date(), 20)}
											maxDate={new Date()} />
										<i className="uil uil-calendar-alt"></i>
									</div>
								</div>
							</div>
							<div className="col-md-2">
								<div className="form-group">
									<label>{t('from_warehouse')}<span className="required-mark">*</span></label>
									<Select
										options={wms}
										value={wms.find(option => option.id === data.from_wms_id)}
										onChange={(option) => {
											setData({ ...data, 'from_wms_id': option.id })
											getProducts(option.id)
										}}
										placeholder=""
										noOptionsMessage={() => t('list_empty')}
										getOptionLabel={(option) => option.name}
										getOptionValue={(option) => option.id}
									/>
								</div>
							</div>
							<div className="col-md-2">
								<div className="form-group">
									<label>{t('to_warehouse')}<span className="required-mark">*</span></label>
									<Select
										options={wms}
										value={wms.find(option => option.id === data.to_wms_id)}
										onChange={(option) => setData({ ...data, 'to_wms_id': option.id })}
										placeholder=""
										noOptionsMessage={() => t('list_empty')}
										getOptionLabel={(option) => option.name}
										getOptionValue={(option) => option.id}
									/>
								</div>
							</div>
							<div className="col-md-2">
								<div className="form-group">
									<label>{t('employee')}<span className="required-mark">*</span></label>
									<Select
										options={employees}
										value={employees.find(option => option.id === data.user_id)}
										onChange={(option) => setData({ ...data, 'user_id': option.id })}
										placeholder=""
										noOptionsMessage={() => t('list_empty')}
										getOptionLabel={(option) => option.name}
										getOptionValue={(option) => option.id}
									/>
								</div>
							</div>
							<div className="col-md-2">
								<div className="form-group">
									<label>{t('note')}</label>
									<input type="text" className="form-control"
										name="note"
										onChange={(e) => setData({ ...data, 'note': e.target.value })} />
								</div>
							</div>
						</div>
						{template === 'template_2' &&
							<div className="form-check">
								<input
									className="form-check-input"
									type="checkbox"
									id="enable_ingredients" // Уникальный ID
									checked={!!data.enable_ingredients}
									onChange={(e) => setData({ ...data, 'enable_ingredients': e.target.checked })}
								/>
								<label className="form-check-label" htmlFor="enable_ingredients">
									{t('show_ingredients')}
								</label>
							</div>
						}
					</div>
				</div>

				{template === 'template_1' &&
					<div className="card" style={{ 'height': 'calc(100vh - 240px)' }}>
						<div className="card-body">
							{template === 'template_1' &&
								<>
									<div style={{ 'height': '45%', 'overflow': 'auto' }}>
										<table className="table table-bordered" style={{ 'overflow': 'unset' }}>
											<thead>
												<tr>
													<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
													<th style={{ 'width': '50%' }}>{t('name2')}</th>
													<th style={{ 'width': '10%' }} className="text-end">{t('balance2')}</th>
													<th style={{ 'width': '5%' }} className="text-nowrap">{t('unit')}</th>
													<th style={{ 'width': '10%' }} className="text-end">
														{t('quantity')}<span className="required-mark">*</span>
													</th>
													<th style={{ 'width': '10%' }} className="text-end">
														{t('cost_price')}
													</th>
													<th style={{ 'width': '20%' }} className="text-end">{t('amount')}</th>
													<th style={{ 'minWidth': '33px' }} className="text-end"></th>
												</tr>
											</thead>
											<tbody>
												{data?.items?.map((item, index) => (
													<tr key={index}>
														<td className="text-center"
															style={{ 'background': data.activeIndex === index ? '#c1c1c1' : '' }}
															onClick={() => setData({ ...data, 'activeIndex': index })}>
															{index + 1}
														</td>

														<td onClick={() => setData({ ...data, 'activeIndex': index })}>
															<ReactSelect
																search={handleSelectSearch}
																value={item.name}
																index={index}
																scrollRef={scrollRef}
																options={items}
																onKeyUp={(e) => {
																	if (e.keyCode === 40 || e.keyCode === 38) {
																		handleTableKeyDown(e)
																	}
																}}
																onClose={() => closeMenu()}
																selectItem={(option) => handleSelectItem(option, index)}
																table={
																	<table className="table mb-0">
																		<tbody ref={tbodyRef}>
																			{items.map((item2, index2) => (
																				<tr
																					id={item2.id}
																					className={"cursor " + ((item2.selected || item2.id === item.element_id) ? 'selected' : '')}
																					tabIndex={-1}
																					key={index2}
																					onClick={() => handleSelectItem(item2, index)}
																					onKeyDown={(e) => handleTableKeyDown(e, item2, index)}>
																					<td style={{ 'width': '50%' }}>{item2.name}</td>
																					<td style={{ 'width': '25%' }} className="text-end text-nowrap">{item2.product_type_name}</td>
																					<td style={{ 'width': '25%' }} className="text-end text-nowrap">{formatMoney(item2.cost_price)}</td>
																				</tr>
																			))}
																		</tbody>
																	</table>
																}
															/>
														</td>
														<td className="text-end"
															onClick={() => setData({ ...data, 'activeIndex': index })}>
															{formatMoney(item.balance)}
														</td>
														<td onClick={() => setData({ ...data, 'activeIndex': index })}>
															{item.unit_name}
														</td>
														<td className="td-input"
															style={!item.quantity ? { 'borderBottom': '2px solid red' } : {}}
															onClick={() => setData({ ...data, 'activeIndex': index })}>
															<input
																type="text"
																name="quantity"
																className="form-control text-end"
																placeholder="0"
																value={item.quantity ?? ''}
																onChange={(e) => handleInputChange(e, index)}
																onKeyDown={(e) => handleDecimalKeyDown(e, (event) => handleInputChange(event, index))} />
														</td>
														<td className="text-end"
															onClick={() => setData({ ...data, 'activeIndex': index })}>
															{formatMoney(returnUnitCostPrice(item))}
														</td>
														<td className="text-end text-nowrap vertical-middle"
															onClick={() => setData({ ...data, 'activeIndex': index })}>
															{formatMoney(item.actual_cost_price)}
														</td>
														<td className="vertical-middle">
															<div className="d-flex justify-content-end">
																<div className="table-action-button table-action-danger-button"
																	onClick={() => deleteItem(index)}>
																	<i className="uil uil-times"></i>
																</div>
															</div>
														</td>
													</tr>
												))}
												<tr>
													<td className="td-input">
														<input
															type="text"
															className="form-control text-center"
															style={{ 'padding': '5px 0' }}
															placeholder="xxx"
															value={addQuantity}
															onChange={(e) => setAddQuantity(e.target.value.replace(/,/g, '.').replace(/[^0-9.]/g, ''))}
														/>
													</td>
													<td colSpan={1} style={{ 'padding': 0 }}>
														<div className="d-flex">
															<div className="w-100">
																<button type="button" className="btn-sm btn-primary w-100"
																	disabled={!data.from_wms_id}
																	onClick={() => {
																		setAddQuantity(1)
																		addToList(addQuantity)
																	}}>
																	{t('add')}
																</button>
															</div>
														</div>
													</td>
													<td></td>
													<td></td>
													<td className="text-end">
														<b>{formatMoney(data.total_quantity)}</b>
													</td>
													<td></td>
													<td className="text-end">
														<b>{formatMoney(data.total_amount)}</b>
													</td>
													<td></td>
												</tr>
											</tbody>
										</table>
									</div>
									<div className="position-relative" style={{ 'height': '3%' }}>
										<span style={{ 'position': 'absolute', 'top': '-10px' }}>{t('ingredients')}</span>
										<hr />
									</div>
									<div style={{ 'height': '45%', 'overflow': 'auto' }}>
										<table className="table table-bordered">
											<thead>
												<tr>
													<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
													<th style={{ 'width': '20%' }}>{t('name2')}</th>
													<th style={{ 'width': '10%' }}>{t('type')}</th>
													<th style={{ 'width': '10%' }} className="text-end">{t('quantity')}</th>
													<th style={{ 'width': '10%' }} className="text-end">{t('quantity')}</th>
													<th style={{ 'width': '10%' }}>{t('unit')}</th>
													<th style={{ 'width': '20%' }} className="text-end">{t('cost_price')}</th>
													<th style={{ 'width': '20%' }} className="text-end">1-{t('cost_price')}</th>
													<th style={{ 'width': '10%' }} className="text-end">{t('balance2')}</th>
												</tr>
											</thead>
											<tbody>
												{returnIngredients().map((item, iIndex) => (
													<tr key={iIndex}>
														<td className="text-center">{iIndex + 1}</td>
														<td>{item.name}</td>
														<td>{item.product_type_name}</td>
														<td className="text-end">{formatMoney(item.quantity, 4)}</td>
														<td className="td-input">
															<input
																type="text"
																name="actual_quantity"
																className="form-control text-end"
																style={isIngredientDeviated(item, data.items[data.activeIndex]?.quantity) ? { 'border': '2px solid red' } : {}}
																placeholder="0"
																value={item.actual_quantity ?? ''}
																onChange={(e) => handleIngredientChange(e, data.activeIndex, iIndex)}
																onKeyUp={(e) => {
																	if (e.keyCode === 13) {
																		calculateQuantity(item, data.activeIndex)
																	}
																}} />
														</td>
														<td>{item.unit_name}</td>
														<td className="text-end">{formatMoney(item.cost_price * item.actual_quantity, 2)}</td>
														<td className="text-end">{formatMoney(item.cost_price, 2)}</td>
														<td className="text-end text-nowrap">{formatMoney(item.balance, 2)}</td>
													</tr>
												))}
											</tbody>
										</table>
									</div>
								</>
							}

							<div className="btn-wrapper gap-2">
								<Link to="/documents-preparation"
									className="btn btn-warning btn-rounded btn-wide"
									tabIndex="-1">
									{t('cancel')}
								</Link>
								<button type="button" className="btn btn-primary btn-rounded btn-wide" tabIndex="-1"
									onClick={() => createUpdate()}>
									{t('confirm')}
								</button>
							</div>
						</div>
					</div>
				}

				{template === 'template_2' &&
					<div className="card">
						<div className="card-body">

							<table className="table table-bordered table-fixed-ellipsis" style={{ 'tableLayout': 'fixed' }}>
								<thead>
									<tr>
										<th style={{ 'width': '45px' }} className="text-center">#</th>
										<th style={{ 'width': '30%' }}>
											<div className="position-relative">
												{t('name2')}
												<div className={`position-absolute cursor ${data?.isBarcodeSearchEnabled ? 'text-primary' : ''}`}
													style={{
														'top': 0,
														'right': '5px'
													}}
													onClick={() => setData({ ...data, 'isBarcodeSearchEnabled': !data.isBarcodeSearchEnabled })}>
													<i className="uil-qrcode-scan"></i>
												</div>
											</div>
										</th>
										<th style={{ 'width': '170px' }}>{t('employee')}</th>
										<th style={{ 'width': '10%' }}>{t('type')}</th>
										<th style={{ 'width': '10%' }} className="text-end">{t('balance2')}</th>
										<th style={{ 'width': '5%' }} className="text-nowrap">{t('unit')}</th>
										<th style={{ 'width': '10%' }} className="text-end">
											{t('quantity')}<span className="required-mark">*</span>
										</th>
										<th style={{ 'width': '10%' }} className="text-end text-nowrap">
											{t('cost_price')}
										</th>
										<th style={{ 'width': '12%' }} className="text-end">{t('amount')}</th>
										<th style={{ 'width': '33px' }} className="text-end"></th>
									</tr>
								</thead>
								<tbody>
									{data?.items?.map((item, index) => (
										<Fragment key={index}>
											<tr>
												<td className={`vertical-middle ${item?.ingredients?.length ? 'cursor' : ''}`}
													style={{ 'padding': '0' }}
													title={item?.ingredients?.length ? t('ingredients') : ''}
													onClick={() => { if (item?.ingredients?.length) toggleItemIngredients(index) }}>
													<div className="d-flex align-items-center justify-content-center text-nowrap">
														<span>{index + 1}</span>
														{item?.ingredients?.length > 0 &&
															<i className={`uil fz-20 ${(data.enable_ingredients || item.show_ingredients) ? 'uil-angle-down' : 'uil-angle-right'} ${item.ingredients.some(ingredient => isIngredientDeviated(ingredient, item.quantity)) ? 'text-danger' : 'text-primary'}`}
																style={{ 'lineHeight': 1 }}></i>
														}
													</div>
												</td>
												<td style={{ 'overflow': 'hidden' }} onClick={() => setData({ ...data, 'activeIndex': index })}>
													<ReactSelect
														search={handleSelectSearch}
														handleSelectSearch={handleSelectSearch}
														value={item.name}
														index={index}
														scrollRef={scrollRef}
														options={items}
														isBarcodeSearchEnabled={data.isBarcodeSearchEnabled}
														onKeyUp={(e) => {
															if (e.keyCode === 40 || e.keyCode === 38) {
																handleTableKeyDown(e)
															}
														}}
														onClose={() => closeMenu()}
														selectItem={(option) => handleSelectItem(option, index)}
														table={
															<table className="table mb-0">
																<tbody ref={tbodyRef}>
																	{items.map((item2, index2) => (
																		<tr
																			id={item2.id}
																			className={"cursor " + ((item2.selected || item2.id === item.element_id) ? 'selected' : '')}
																			tabIndex={-1}
																			key={index2}
																			onClick={() => handleSelectItem(item2, index)}
																			onKeyDown={(e) => handleTableKeyDown(e, item2, index)}>
																			<td style={{ 'width': '50%' }}>{item2.name}</td>
																			<td style={{ 'width': '25%' }} className="text-end text-nowrap">{item2.product_type_name}</td>
																			<td style={{ 'width': '25%' }} className="text-end text-nowrap">{formatMoney(item2.cost_price)}</td>
																		</tr>
																	))}
																</tbody>
															</table>
														}
													/>
												</td>
												<td style={{ 'overflow': 'hidden' }}>
													<ReactSelect
														tabIndex={-1}
														uniqueId="select2"
														isClearable
														search={handleSelectSearch}
														handleSelectSearch={handleSelectSearch}
														handleClearSelect={handleClearSelect}
														value={item.user_name}
														index={index}
														scrollRef={scrollRef}
														options={employees}
														onKeyUp={(e) => {
															if (e.keyCode === 40 || e.keyCode === 38) {
																handleTableKeyDown(e)
															}
														}}
														onClose={() => closeMenu()}
														selectItem={(option) => handleSelectEmployee(option, index)}
														table={
															<table className="table mb-0">
																<tbody ref={tbodyRef}>
																	{employees.map((item2, index2) => (
																		<tr
																			id={item2.id}
																			className={"cursor " + ((item2.selected || item2.id === item.user_id) ? 'selected' : '')}
																			tabIndex={-1}
																			key={index2}
																			onClick={() => handleSelectEmployee(item2, index)}
																			onKeyDown={(e) => handleTableKeyDown(e, item2, index)}>
																			<td style={{ 'width': '100%' }}>{item2.name}</td>
																		</tr>
																	))}
																</tbody>
															</table>
														}
													/>
												</td>
												<td>{item.product_type_name}</td>
												<td className="text-end"
													onClick={() => setData({ ...data, 'activeIndex': index })}>
													{formatMoney(item.balance)}
												</td>
												<td onClick={() => setData({ ...data, 'activeIndex': index })}>
													{item.unit_name}
												</td>
												<td className="td-input"
													style={!item.quantity ? { 'borderBottom': '2px solid red' } : {}}
													onClick={() => setData({ ...data, 'activeIndex': index })}>
													<input
														type="text"
														name="quantity"
														className="form-control text-end"
														placeholder="0"
														value={item.quantity ?? ''}
														onChange={(e) => handleInputChange(e, index)}
														onKeyDown={(e) => handleDecimalKeyDown(e, (event) => handleInputChange(event, index))} />
												</td>
												<td className="text-end"
													onClick={() => setData({ ...data, 'activeIndex': index })}>
													{formatMoney(returnUnitCostPrice(item))}
												</td>
												<td className="text-end text-nowrap vertical-middle"
													onClick={() => setData({ ...data, 'activeIndex': index })}>
													{formatMoney(item.actual_cost_price)}
												</td>
												<td className="vertical-middle">
													<div className="d-flex justify-content-end">
														<div className="table-action-button table-action-danger-button"
															onClick={() => deleteItem(index)}>
															<i className="uil uil-times"></i>
														</div>
													</div>
												</td>
											</tr>
											{(data.enable_ingredients || item.show_ingredients) &&
												<Fragment>
													{item?.ingredients?.map((ingredient, iIndex) => (
														<tr key={iIndex}>
															<td></td>
															<td><i style={{ 'paddingLeft': `10px` }}>{ingredient.name}</i></td>
															<td className="text-end text-muted text-nowrap">
																{t('norm')}: {formatMoney((Number(ingredient.quantity) || 0) * (Number(item.quantity) || 0), 4)}
															</td>
															<td>{ingredient.product_type_name}</td>
															<td className="text-end">{formatMoney(ingredient.balance, 4)}</td>
															<td>{ingredient.unit_name}</td>
															<td className="td-input">
																<input
																	type="text"
																	name="actual_quantity"
																	className="form-control text-end"
																	style={isIngredientDeviated(ingredient, item.quantity) ? { 'border': '2px solid red' } : {}}
																	placeholder="0"
																	value={ingredient.actual_quantity ?? ''}
																	onChange={(e) => handleIngredientChange(e, index, iIndex)}
																	onKeyUp={(e) => {
																		if (e.keyCode === 13) {
																			calculateQuantity(ingredient, index)
																		}
																	}} />
															</td>
															<td className="text-end">{formatMoney(ingredient.cost_price, 2)}</td>
															<td className="text-end">{formatMoney(ingredient.cost_price * ingredient.actual_quantity, 2)}</td>
															<td className="text-end text-nowrap"></td>
														</tr>
													))}
												</Fragment>
											}
										</Fragment>
									))}

									<tr>
										<td className="td-input">
											<input
												type="text"
												className="form-control text-center"
												style={{ 'padding': '5px 0' }}
												placeholder="xxx"
												value={addQuantity}
												onChange={(e) => setAddQuantity(e.target.value.replace(/,/g, '.').replace(/[^0-9.]/g, ''))}
											/>
										</td>
										<td colSpan={1} style={{ 'padding': 0 }}>
											<div className="d-flex">
												<div className="w-100">
													<button type="button" className="btn-sm btn-primary w-100"
														disabled={!data.from_wms_id}
														onClick={() => {
															setAddQuantity(1)
															addToList(addQuantity)
														}}>
														{t('add')}
													</button>
												</div>
											</div>
										</td>
										<td></td>
										<td></td>
										<td></td>
										<td></td>
										<td className="text-end">
											<b>{formatMoney(data.total_quantity, 3)}</b>
										</td>
										<td></td>
										<td className="text-end">
											<b>{formatMoney(data.total_amount)}</b>
										</td>
										<td></td>
									</tr>
								</tbody>
							</table>

							<div className="btn-wrapper gap-2">
								<Link to="/documents-preparation"
									className="btn btn-warning btn-rounded btn-wide"
									tabIndex="-1">
									{t('cancel')}
								</Link>
								<button type="button" className="btn btn-primary btn-rounded btn-wide" tabIndex="-1"
									onClick={() => createUpdate()}>
									{t('confirm')}
								</button>
							</div>
						</div>
					</div>
				}
			</form>

			{/* MODAL TEMPLATE */}
			<Modal show={modalTemplate.bool} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => toggleModalTemplate()}>
				<Modal.Header closeButton>
					<Modal.Title>{t('templates')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="table-responsive">
						<table className="table table-bordered table-hover cursor mb-0">
							<thead>
								<tr>
									<th style={{ 'width': '10px' }}>#</th>
									<th>{t('name2')}</th>
									<th></th>
								</tr>
							</thead>
							<tbody>
								{modalTemplate?.templates?.map((item, index) => (
									<tr key={index}>
										<td>{index + 1}</td>
										<td onClick={() => handleSelectTemplate(item)}>
											{item.name}
										</td>
										<td>
											<div className="d-flex justify-content-end">
												<div className="table-action-button table-action-danger-button"
													onClick={() => deleteTemplate(item)}>
													<i className="uil uil-times"></i>
												</div>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL TEMPLATE */}

			{/* MODAL DEVIATION */}
			<Modal show={modalDeviation.bool} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => setModalDeviation({ 'bool': false, 'rows': [] })}>
				<Modal.Header closeButton>
					<Modal.Title>{t('ingredient_deviation_title')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<p>{t('ingredient_deviation_text')}</p>
					<div className="table-responsive" style={{ 'maxHeight': '50vh', 'overflowY': 'auto' }}>
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th>{t('name2')}</th>
									<th>{t('ingredient')}</th>
									<th className="text-end">{t('norm')}</th>
									<th className="text-end">{t('fact')}</th>
								</tr>
							</thead>
							<tbody>
								{modalDeviation.rows.map((row, index) => (
									<tr key={index}>
										<td>{row.product}</td>
										<td>{row.ingredient}</td>
										<td className="text-end text-nowrap">{formatMoney(row.norm, 4)} {row.unit_name}</td>
										<td className="text-end text-nowrap text-danger">{formatMoney(row.actual, 4)} {row.unit_name}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<div className="d-flex w-100">
						<button className="btn btn-warning w-100 me-2" onClick={() => setModalDeviation({ 'bool': false, 'rows': [] })}>
							{t('cancel')}
						</button>
						<button className="btn btn-primary w-100" onClick={() => createUpdate(true)}>{t('confirm')}</button>
					</div>
				</Modal.Footer>
			</Modal>
			{/* MODAL DEVIATION */}
		</>
	)
}

export default CreateUpdate